import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { enqueueSnackbar } from 'notistack';

import { environment } from '@env';

import { StripeMonthlyPayments } from '@/types/stripe';

import { useAuth } from '@/context/AuthProvider';

export const useStripeMonthlyPayments = () => {
  const { session } = useAuth();

  return useQuery({
    enabled: !!session?.access_token,
    queryKey: ['GET', 'stripe', 'monthly-payments', session?.access_token],
    queryFn: async () => {
      try {
        const response = await axios.get<StripeMonthlyPayments>(
          `${environment.api}/stripe/monthly-payments`,
          {
            headers: {
              Authorization: `Bearer ${session?.access_token}`,
            },
          }
        );
        return response.data;
      } catch (error) {
        enqueueSnackbar('Failed to fetch monthly payments.', { variant: 'error' });
        return null;
      }
    },
  });
};
